import React, { useState, useRef } from "react";
import "../css/main/Breadcrumbs.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaChevronDown, FaSignOutAlt } from "react-icons/fa";
import EncryptionUtils from "./encryptionUtils";
type BreadcrumbsProps = { handleLogout: () => void; };
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ handleLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [, setMoveUp] = useState(false);
  const email = EncryptionUtils.get<string>("email");
  const handleProfileClick = () => {
    setShowDropdown((prev) => !prev);
    setMoveUp((prev) => !prev);
  };
  const pathnames = location.pathname.split("/").filter(Boolean);
  const breadcrumbConfig: { [key: string]: any[] } = {
    client: [["/dashboard", "Dashboard"], [null, "Clients"],],
    "client-details": [["/dashboard", "Dashboard"], ["/client", "Clients"], [null, `Client Details ${pathnames[1]?.toUpperCase()}`]],
    "Createclient": [["/dashboard", "Dashboard"], ["/client", "Clients"], [null, `Create Client`],],
    checklistmanagement: [["/dashboard", "Dashboard"], [null, "Checklists"]],
    "checklistdetails": [["/dashboard", "Dashboard"], ["/checklistmanagement", "Checklists"], [null, `Checklist Details`]],
    "viewchecklistdetails": [["/dashboard", "Dashboard"], ["/checklistmanagement", "Checklists"], [null, `Checklist Details`]],
    templates: [["/dashboard", "Dashboard"], [null, `Email Template`]],
    "templatesdetails": [["/dashboard", "Dashboard"], [null, `Email Template  ${pathnames[1]?.toUpperCase()}`]],
    "createtemplate": [["/dashboard", "Dashboard"], [() => navigate(-1), `Email Template ${pathnames[1]?.toUpperCase()}`], [null, `Create New Email Template ${pathnames[1]?.toUpperCase()}`]],
    "emailtemplatedetail": [["/dashboard", "Dashboard"], [() => navigate(-1), `Email Template ${pathnames[1]?.toUpperCase()}`], [null, `Email Template Detail ${pathnames[1]?.toUpperCase()}`]],
    customizetheme: [["/dashboard", "Dashboard"], ["/customizetheme", `Customize Theme`]],
    idpConfiguration: [["/dashboard", "Dashboard"], [null, `IDP Configuration`]],
    functionchecklist: [["/dashboard", "Dashboard"], [null, `Function Checklist`]],
    functionchecklistdetails: [["/dashboard", "Dashboard"], [() => navigate(-1), `Function Checklist`], [null, `Function Checklist Details`]],
    functionviewchecklistdetails: [["/dashboard", "Dashboard"], [() => navigate(-1), `Function Checklist`], [null, `Function Checklist Details`]],
  };
  const renderBreadcrumb = (link: string | null | (() => void), label: string, index: number) => {
    if (typeof link === "function") {
      return (
        <li key={index} className="breadcrumb-item">
          <span className="breadcrumb-link" onClick={link}>
            {label}
          </span>
        </li>
      );
    }
    return link ? (
      <li key={index} className="breadcrumb-item">
        <Link to={link} className="breadcrumb-link">
          {label}
        </Link>
      </li>
    ) : (
      <li key={index} className="breadcrumb-item active" aria-current="page">
        {label}
      </li>
    );
  };
  const handleDropdownItemClick = () => {
    setShowDropdown(false);
    handleLogout();
  }
  const breadcrumbs = breadcrumbConfig[pathnames[0]] || [["/dashboard", "Dashboard"]];
  return (
    <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
      <ol className="breadcrumb">
        {breadcrumbs.map(([link, label], index) => renderBreadcrumb(link, label, index))}
      </ol>
      <div className="profile-topbar" onClick={handleProfileClick} ref={dropdownRef} onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() =>
        setTimeout(() => {
          if (!dropdownRef.current?.matches(":hover")) {
            setShowDropdown(false);
          }
        }, 200)
      }>
        <div className="profile-name-role">
          <span className="profile-name">{email}</span>
        </div>
        <FaChevronDown className={`dropdown-icon ${showDropdown ? "open" : ""}`} />
        {showDropdown && (
          <div className="profile-dropdown" onMouseEnter={() => setShowDropdown(true)} onMouseLeave={() =>
            setTimeout(() => {
              if (!dropdownRef.current?.querySelector(".profile-topbar:hover")) {
                setShowDropdown(false);
              }
            }, 200)}>
            <div className="dropdown-item" onClick={handleDropdownItemClick}>
              <FaSignOutAlt size={20} className="dropdown-item-icon" />
              <span>Logout</span>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
export default Breadcrumbs;